import { Directive, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Column } from '../../../lib/data-set/column';

@Directive()
export class DefaultFilter implements Filter, OnDestroy {

  public delay: number = 300;
  public changesSubscription: Subscription;
  @Input() public query: string;
  @Input() public inputClass: string;
  @Input() public column: Column;
  @Output() public filter = new EventEmitter<string>();

  public ngOnDestroy() {
    if (this.changesSubscription) {
      this.changesSubscription.unsubscribe();
    }
  }

  public setFilter() {
    this.filter.emit(this.query);
  }
}

export interface Filter {

  delay?: number;
  changesSubscription?: Subscription;
  query: string;
  inputClass: string;
  column: Column;
  filter: EventEmitter<string>;
}
